import axios from "axios";

import $ from "jquery";

const api = axios.create({
    headers: {
        "X-Custom-Header": $('meta[name="csrf-token"]').attr("content"),
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
});

const api_erp = axios.create({
    baseURL: window.url_erp,
});

export { api_erp };
export default api;
